import { useMemo } from 'react'

import { useAuthInfo } from '@sweetauth/core'

import type { UUID } from '@/types/Id'
import type { User } from '@/types/User'

export const useAuthInfoWithThrow = () => {
  const { user, accessToken } = useAuthInfo()
  const userId = user?.userId

  if (!userId || !accessToken) {
    throw new Error('User not logged in')
  }

  return useMemo(() => ({ user, accessToken }), [user.userId, accessToken])
}

interface UseDbUserWithThrowData {
  user: User
  accessToken: string
}

export const useDbUserWithThrow = (): UseDbUserWithThrowData => {
  const { user, accessToken } = useAuthInfoWithThrow()
  const userId = user?.userId

  if (!userId || !accessToken) {
    throw new Error('User not logged in')
  }

  return useMemo(
    () => ({
      user: {
        id: user.userId as UUID,
        first_name: user.firstName ?? '',
        last_name: user.lastName ?? '',
        email: user.email,
        picture_url: user.pictureUrl,
        // TODO: this is a bit hacky but whatever
        created_at: new Date(user.createdAt),
        last_modified: new Date(user.createdAt),
      },
      accessToken,
    }),
    [user.userId, accessToken],
  )
}
